export default __webpack_public_path__ + "5c60f7c9b7581edb863d7b3e5e2a8509.png";